<template>
  <div class='EnbNaveMobi'
  :style="{ 
      backgroundColor: Prefes.nave.corBackground,
      fontFamily: Prefes.nave.font,
      color: Prefes.nave.corFont,
      fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
      fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
      textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
      fontSize: Prefes.nave.fontHeight + 'px'
    }"
  >
    <div class="link-nave">
      <nave-icon :color="Prefes.nave.corFont" @click="ToggleSideNave(true)"/>
    </div>
    <enb-logo01/>
    <cart-btn @click="ToggleCheckout01(true)" v-if="Empresa.modelo !== 'Modelo 03'"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CartBtn from '@/components/Theme01/Checkout/CartBtn'
import EnbLogo01 from '@/components/Theme01/Nave/EnbLogo01'
import NaveIcon from '../Icons/NaveIcon'
export default {
  name: 'EnbNaveMobi',
  components: { CartBtn, EnbLogo01, NaveIcon },
  computed: {
    ...mapGetters(['Empresa', 'Prefes'])
  },
  methods: {
    ...mapActions(['ToggleCheckout01', 'ToggleSideNave'])
  }
}
</script>

<style scoped>
.EnbNaveMobi {
  width: 100%;
  height: 20%;
  align-items: center;
}

.link-nave {
  width: 15%;
}

label {
  display: block;
  transform: rotate(90deg);
}

@media screen and (min-width: 500px) {
  .EnbNaveMobi {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .EnbNaveMobi {
    display: flex;
  }
}
</style>
